/******************************************************************************
 * ImageLoader Class
 * version: 1.0.1, release: 07.09.2018
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
******************************************************************************/

/* state
	0 = init / cleared
	1 = loading
	2 = loaded
	3 = error
*/


//============================================================================= ImageLoader Class
export class ImageLoader {
	constructor(props){
		this.image = props.image || new Image();
		this.image.onload = this.onImageLoad.bind(this);
		this.image.onerror = this.onImageError.bind(this);

		if (props){
			for (let e in props) this[e] = props[e];
			if (props.src) this.load(props.src);
		}
		this.state = 0;
		this.width = 0;
		this.height = 0;
	}

	load(src){
		this.source = src;
		this.isLoaded = false;
		this.isError = false;
		this.isLoading = true;
		this.state = 1;
		this.image.src = src;
	}

	onImageLoad(e){
		this.isLoading = false;
		this.isLoaded = true;
		this.state = 2;
		this.width = this.image.width;
		this.height = this.image.height;
		this.onLoad && this.onLoad(this);
	}

	onImageError(){
		this.isLoading = false;
		this.isError = true;
		this.state = 3;
		this.onError && this.onError(this);
	}
}
